export default "__VITE_ASSET__D$JRUKiO__"